import { normalizeToPrecision, toBig } from '@core/utils/big-number.util';
import { ServiceProviderCommissionCalculationType } from '@core/enums/commission.enum';
import { FeeBreakdownInput, FeeBreakdownResult } from './fee-breakdown.model';

export function computeFeeBreakdown(
  input: FeeBreakdownInput,
): FeeBreakdownResult {
  const precision = input.precision ?? 8;
  const {
    requestAmount,
    quantity,
    buyRate,
    commission,
    discount,
    fromCurrencyName,
    toCurrencyName,
  } = input;

  const conversionAmount = normalizeToPrecision(
    toBig(requestAmount).times(quantity).times(buyRate).toString(),
    precision,
  );

  const commissionType = commission?.calculationType ?? null;
  const commissionValue = commission?.value ?? '0';
  const commissionPercent =
    commissionType === ServiceProviderCommissionCalculationType.Percentage &&
    commissionValue !== '0'
      ? commissionValue
      : '0';
  const commissionAmount =
    commissionType === null || commissionValue === '0'
      ? '0'
      : commissionType === ServiceProviderCommissionCalculationType.Percentage
        ? normalizeToPrecision(
            toBig(conversionAmount)
              .mul(toBig(commissionValue))
              .div(100)
              .toString(),
            precision,
          )
        : normalizeToPrecision(commissionValue, precision);

  const discountType = discount?.calculationType ?? null;
  const discountValue = discount?.value ?? '0';
  const discountPercent =
    discountType === ServiceProviderCommissionCalculationType.Percentage &&
    discountValue !== '0'
      ? discountValue
      : '0';
  const discountAmount =
    discountType === null || discountValue === '0'
      ? '0'
      : discountType === ServiceProviderCommissionCalculationType.Percentage
        ? normalizeToPrecision(
            toBig(conversionAmount)
              .mul(toBig(discountValue))
              .div(100)
              .toString(),
            precision,
          )
        : normalizeToPrecision(discountValue, precision);

  const finalPaymentAmount = normalizeToPrecision(
    toBig(conversionAmount)
      .plus(commissionAmount)
      .minus(discountAmount)
      .toString(),
    precision,
  );

  const hasDiscount = discountType !== null && discountValue !== '0';
  const originalAmount = hasDiscount
    ? normalizeToPrecision(
        toBig(finalPaymentAmount).plus(discountAmount).toString(),
        precision,
      )
    : null;

  return {
    serviceProviderItemId: '',
    requestAmount,
    fromCurrencyName,
    toCurrencyName,
    fromPrecision: precision,
    toPrecision: precision,
    buyRate,
    conversionAmount,
    commissionCalculationType: commissionType,
    commissionValue,
    commissionPercent,
    commissionAmount,
    discountPercent,
    discountAmount,
    finalPaymentAmount,
    originalAmount,
  };
}
